export default {
  root: {
    class: [
      // Shape
      'rounded-sm shadow ring ring-1 ring-surface-700/20 dark:ring-surface-300/20',

      // Position
      'absolute left-0 top-0 mt-2',
      'z-40 transform origin-center',

      // Color
      'bg-white dark:bg-gray-800',
      'text-brand-text dark:text-gray-100'

      // Before: Arrow
      //'before:absolute before:shadow-sm before:w-0 before:-top-3 before:h-0 before:border-transparent before:border-solid before:ml-[10px] before:border-x-[10px] before:border-b-[10px] before:border-t-0 before:border-b-white dark:before:border-b-white',
      //'after:absolute after:w-0 after:-top-[0.54rem] after:left-[4px] after:h-0 after:border-transparent after:border-solid after:ml-[8px] after:border-x-[8px] after:border-b-[8px] after:border-t-0 after:border-b-white dark:after:border-b-white'
    ]
  },
  content: {
    class: ['p-5 items-center flex', 'rounded-lg']
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0'
  }
}
